import React from 'react';
import styled from 'styled-components';

interface CustomToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id: string;
}

const CustomToggle: React.FC<CustomToggleProps> = ({ checked, onChange, id }) => {
  return (
    <StyledWrapper>
      <div>
        <input 
          type="checkbox" 
          name={`check-toggle-${id}`} 
          id={`checkbox-${id}`} 
          hidden 
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label htmlFor={`checkbox-${id}`} className="toggle">
          G
          <div className="toggle__switch">
            <div className="toggle__circle" />
          </div>
          D
        </label>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .toggle {
    display: flex;
    align-items: center;
    gap: .2rem;
    font-weight: 900;
    font-size: 1.5rem;
    color: hsl(119, 84%, 10%);
    text-shadow: 0 0 2px #e8e8e8;
  }

  .toggle__switch {
    --bg-toggle: hsl(0, 0%, 100%);
    --bg-circle: hsl(119, 84%, 10%);
    --w-toggle-switch: 80px;
    --w-h-toggle-circle: 20px;
    --pd-toggle-switch: .3rem;
    height: 30px;
    width: var(--w-toggle-switch);
    background-color: var(--bg-toggle);
    border-radius: 4rem;
    display: flex;
    align-items: center;
    padding: 0 var(--pd-toggle-switch);
    cursor: pointer;
    transition: background-color 500ms;
  }

  .toggle__circle {
    width: var(--w-h-toggle-circle);
    height: var(--w-h-toggle-circle);
    background-color: var(--bg-circle);
    border-radius: 50%;
    transition: margin 400ms ease-in-out, background-color 1000ms;
  }

  input[type="checkbox"]:checked + .toggle .toggle__circle {
    margin-left: calc(var(--w-toggle-switch) - (var(--pd-toggle-switch) * 2) - var(--w-h-toggle-circle));
  }

  input[type="checkbox"]:checked + .toggle > .toggle__switch {
    --bg-toggle: hsl(119, 84%, 10%);
    --bg-circle: hsl(0, 0%, 96%);
    box-shadow: 0 .3rem 5rem 0 hsla(96, 85%, 34%, 30%);
  }
`;

export default CustomToggle;
